(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-template-boost-pfs-filter"]) return;
  try {
    
  function initBoostMobileFilter() {
    const container = document.querySelector('#shopify-section-collection-template-boost-pfs-filter')
    const selector = '#boost-pfs-filter-tree';

    // Wait for the tree to become visible
    waitFor(container, selector, (element) => {
      const classes = {
        container: ['bst-mobile-inline-override', 'bst-override'],
        open: 'boost-pfs-filter-tree-mobile-open',
        lockScroll: 'boost-pfs-body-no-scroll'
      };

      // Add this class to the container so we can easily modify the css within a scope
      container.classList.add(...classes.container)

      const onMobileFilterOpened = () => {
        // Remove the body lock scroll without changing the CSS
        // because doing that might have unexpected consequences
        document.documentElement.classList.remove(classes.lockScroll);
        document.body.classList.remove(classes.lockScroll);
      };

      // Wait for the element to open
      waitForClass(
        element,
        classes.open,
        onMobileFilterOpened,
        { once: false }
      );
    })
  }

  window.addEventListener('load', function () {
    initBoostMobileFilter();
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["covet-pics"] && !window.DesignMode) return;
  try {
    
  const customLayoutStyles = {
    homepage: `
      covet-pics-gallery-item {
        margin: 0 !important;
      }

      .swiper-button-next,
      .swiper-button-prev {
        height: 0.75rem !important;
        width: auto !important;
        top: 50% !important;
      }

      .swiper-button-next svg,
      .swiper-button-prev svg {
        background-color: transparent !important;
        opacity: 100% !important;
      }

      .swiper-button-next svg path,
      .swiper-button-prev svg path {
        fill: #C26F51 !important;
      }
    `,
  };

  /**
  * A workaroud to add styling to the covet pics widget.
  * A <style></style> tag is injected into the <covet-pics-widget></covet-pics-widget> element in order to apply custom styling
  *
  * The reason why, is beacuse it's a custom HTML element with the shadow DOM enabled so any external css will be ignored.
  * The only way to apply custom CSS is by injecting it into the component.
  *
  * This script works by querying all .js-covet-pics selector and applying the correct styling based on the [data-custom-layout] attribute
  */
  class CovetPics extends HTMLElement {
    constructor() {
      super();
      this.elements = Array.from(document.querySelectorAll('.js-covet-pics'));
    }

    /**
    * @param {HTMLDivElement} root
    * @param {string} customLayout
    */
    createStyleTag(root, customLayout) {
      const styleTag = document.createElement('style');
      const css = customLayoutStyles[customLayout];
      styleTag.innerHTML = css;
      styleTag.dataset.isCustomLayout = true;
      styleTag.dataset.customLayout = customLayout;
      root.appendChild(styleTag);
    }

    initCovetPicsCustomLayout() {
      this.elements.forEach((element) => {
        const customLayout = element.getAttribute('data-custom-layout');
        const widget = element.querySelector('covet-pics-widget');

        if (!widget) return;

        const observer = new MutationObserver(function (mutationList) {
          const classListMutation = mutationList.find(
            (mutation) => mutation.type === 'attributes'
          );
          const isHydrated =
            classListMutation && widget.classList.contains('hydrated');
          if (!isHydrated) return;

          observer.disconnect();
          this.createStyleTag(widget.shadowRoot, customLayout);

          waitFor(widget.shadowRoot, '.swiper-button-next', () => {
            widget.shadowRoot
              .querySelectorAll('.swiper-button-next')
              .forEach((nextButton) => {
                nextButton.innerHTML = `<svg width="98" height="16" viewBox="0 0 98 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M97.7071 8.70711C98.0976 8.31658 98.0976 7.68342 97.7071 7.29289L91.3431 0.928932C90.9526 0.538408 90.3195 0.538408 89.9289 0.928932C89.5384 1.31946 89.5384 1.95262 89.9289 2.34315L95.5858 8L89.9289 13.6569C89.5384 14.0474 89.5384 14.6805 89.9289 15.0711C90.3195 15.4616 90.9526 15.4616 91.3431 15.0711L97.7071 8.70711ZM0 9H97V7H0L0 9Z" fill="#C26F51"/>
                </svg>
                `;
              });

            widget.shadowRoot
              .querySelectorAll('.swiper-button-prev')
              .forEach((nextButton) => {
                nextButton.innerHTML = `<svg width="98" height="16" viewBox="0 0 98 16" fill="none" style="transform: rotate(0deg);" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.292892 7.29289C-0.0976334 7.68342 -0.0976334 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41422 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM98 7L1 7V9L98 9V7Z" fill="#C26F51"/>
                </svg>
                `;
              });
          });
        });

        observer.observe(widget, {
          attributes: true,
          childList: false,
          characterData: false,
          subtree: false,
          attributeFilter: ['class'],
          characterDataOldValue: false,
          attributeOldValue: true,
        });
      });
    }
  }

  customElements.define('covet-pics', CovetPics);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcement = document.getElementById('shopify-section-announcement-bar');
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};

      this.currentScrollTop = this.announcement.offsetHeight || 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function swymCallbackFn(swat) {
    document.addEventListener("variantChange", function(event) {
      /* the current selected variant id */
      var variantId = event.detail.variant.id;
      window.triggerSwymVariantEvent(variantId);
      /* parent container of the where the button is rendered */
      swat.initializeActionButtons(".js-wishlist-button-wrapper");
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  } catch(e) { console.error(e); }
})();

})();
